module.exports = __webpack_public_path__ + "img/loading-obj.49bb8216.png";